import { Button } from "@material-ui/core";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import { Keyboard } from "@material-ui/icons";
import GoogleLogo from "src/assets/2702602.png";
import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { buttonOffset } from "src/pages/home/Home";
import { ILogin } from "src/services";
import Component from "./Component";
import GoogleCallback from "./login/GoogleCallback";
import { AppContextConsumer, IAppContext } from "./withAppContext";
import withAxios, { IAxiosProps } from "./withAxios";
import { decodeEmailQueryParam } from "src/utils/queryParams";

const styles = () => ({
  text: {
    color: "white",
  },
});

interface ILoginFormState {
  error: boolean;
  submitting: boolean;
  urlEmail: string;
}

type IProps = IAppContext &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

const LoginForm = withStyles(styles)(
  withAxios(
    class extends Component<IProps, ILoginFormState> {
      public readonly state: Readonly<ILoginFormState> = {
        error: false,
        submitting: false,
        urlEmail: '',
      };

      public componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = decodeEmailQueryParam(urlParams.get("email"));
        if(email) {
          this.setState({ urlEmail: email });
        }
      }

      public render() {
        const { classes } = this.props;
        const { error, submitting } = this.state;
        if (submitting) {
          return <Typography className={classes.text}>Submitting…</Typography>;
        }
        return (
          <form>
            {error && (
              <Typography style={{color:"red",marginBottom:"5px"}} className={classes.text}>
                There was an error.
              </Typography>
            )}
            <Switch>
              <Route
                path="/sign-in/google/callback"
                render={this.renderGoogleCallback}
              />
              <Route path="/sign-in" render={this.renderGoogleButton} />
            </Switch>
          </form>
        );
      }

      private renderGoogleButton = () => {
        return (
          // <Button
          //   variant="contained"
          //   color="primary"
          //   onClick={this.handleGoogleClick}
          //   style={{ marginLeft: buttonOffset }}
          //   startIcon={<Keyboard />}
          // >
          //   Sign in with Google
          // </Button>
           <Button
                    className="button-signup"
                      variant="contained"
                      color="primary"
                      onClick={this.handleGoogleClick}
                      style={{ marginLeft: buttonOffset }}
                    >
                      <img src={GoogleLogo} style={{marginRight:"10px"}}/>
                      Sign In with Google
                    </Button>
        );
      };

      private handleGoogleClick = async () => {
  const token = localStorage.getItem("invitationToken");
  const email = localStorage.getItem("invitationEmail");
  localStorage.clear();
  // 👉 Step 1: Accept invitation first (if exists)
  if (token && email) {
    try {
      await this.buildPost(this, "/accept-invitation")({ token, email });
      console.log("Invitation accepted successfully");

      localStorage.removeItem("invitationToken");
      localStorage.removeItem("invitationEmail");
      
    } catch (err: any) {
      console.error("Error accepting invitation:", err);
      return; // ❌ STOP — redirect nahi hoga
    }
  }

  // 👉 Step 2: Only after successful accept (or no token), redirect
  void this.runCancellableStatefulAsync(
    this,
    {
      error: false,
      submitting: true,
    },
    {
      submitting: false,
    },
    async () => {
      localStorage.setItem("showtour", JSON.stringify(true));
      sessionStorage.setItem("isFirstVisit", "true");

      const response = await this.buildGet<ILogin>(
        this,
        "sign-in/google"
      )();

      location.href = response.url; // ✅ redirect here only
    },
    () => {
      this.setState({
        error: true,
        submitting: false,
      });
    }
  );
};

      private renderGoogleCallback = (props: RouteComponentProps<any>) => {
        return (
          <Typography className={this.props.classes.text}>
            <GoogleCallback {...props} {...this.props} />
          </Typography>
        );
      };
    }
  )
);

export default () => (
  <AppContextConsumer>
    {(context) => <LoginForm {...context} />}
  </AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/LoginForm.tsx